"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONBlock = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var JSONBlock = function (_a) {
    var data = _a.data, props = __rest(_a, ["data"]);
    return (jsx_runtime_1.jsx("div", __assign({}, props, { children: jsx_runtime_1.jsx("pre", { children: JSON.stringify(data, null, 2) }, void 0) }), void 0));
};
exports.JSONBlock = JSONBlock;
//# sourceMappingURL=index.js.map